import '../Admin/admin-shared.css'
import '../tools-pages.css'

import { useNavigate } from 'react-router-dom'

import { PageHeader } from '../../Components'
import { cap } from '../../State'
import { translations } from '../../translations'
import { PromptsTable } from './PromptsTable'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

export default function TabPrompts() {
  const navigate = useNavigate()

  return (
    <>
      <PageHeader
        title={t.mxElencoPrompts}
        subtitle={t.mxPromptLLMSubtitle}
        actions={
          <button
            type="button"
            className="nbtn nbtn--primary"
            onClick={() => navigate('/prompts/new')}
          >
            <i className="pi pi-plus" style={{ fontSize: 14 }} />
            {t.createNew}
          </button>
        }
      />

      <div className="nora-tabs" style={{ marginBottom: 14 }}>
        <button type="button" className="nora-tab is-active">
          {t.mxElencoPrompts}
        </button>
      </div>

      <PromptsTable />
    </>
  )
}
